<script>
import options from "./ContactAdvisorBlock.options"
export default options
</script>

<template>
    <nyk-form
        :formId="formId"
        :formGuid="formGuid"
        :formTitle="formTitle"
        :formType="'contact-advisor'"
        :apiPath="apiPath"
        :antiForgeryToken="antiForgeryToken"
        :formElements="formElements"
        :queryParams="queryParams"
        :confirmationMessage="labels.confirmationMessage"
        :submitSuccessMessage="labels.submitSuccessMessage"
        :submitErrorMessage="labels.submitErrorMessage"
        :resetAfterSubmission="true"
        :queryParamFields="queryParamFields">
    </nyk-form>
</template>